// 新闻页面接口
import {get,post} from '../utils/request.js'

//获取静态数据
export const apiStatePage = function (data) {
  return get('info/getList', data);
}

//获取筛选列表数据
export const apiGetList = function (data) {
  return get('info/getArticleList', data);
}

//详情
export const apiGetDetail = function (data) {
  return get('info/getArticleDetail', data);
}




// WEBPACK FOOTER //
// ./src/api/message.js